<template>
    <div>
        <v-container style="text-align: center" v-if="!hideToolbar">
                  <h2
                  :style="{
                            fontSize: '24px',
                            color: configData.secondaryColour
                        }"
                  >
                    SELECT YOUR PACKAGE
                  </h2>
                </v-container>
                <v-row v-if="network&&network.routerInstallationFee&&!hideToolbar">
                  <v-col cols="12" sm="12">
                    <h4
                      :style="{
                          'padding-left': '20px',
                        color: $store.state.currentOrg.orderSecondaryColour
                          ? $store.state.currentOrg.orderSecondaryColour
                          : $store.state.currentOrg.secondaryColour,
                      }"
                    >
                      Installation Fees: <span style="fontWeight: light; color: grey">
                          <h4 style="font-weight: light; color: grey"
                      v-if="
                        network.routerInstallationFee && (network.residentialRouterInstallationFeeAmount > 0 || network.businessRouterInstallationFeeAmount > 0) &&
                        network.businessRouterInstallationFeeAmount != network.residentialRouterInstallationFeeAmount
                      "
                      class="align-left"
                    >
                      An installation fee of
                      <b>{{ network.residentialRouterInstallationFeeAmount | currency }} </b> applies for Residential Packages and
                      <b>{{ network.businessRouterInstallationFeeAmount | currency }}</b> for Business Packages.
                    </h4>
                    <h4 style="font-weight: light; color: grey"
                      v-else-if="network.routerInstallationFee && network.residentialRouterInstallationFeeAmount > 0"
                      class="text-xs-left"
                    >
                      An installation fee of
                      <b>{{ network.residentialRouterInstallationFeeAmount | currency }}</b> may apply upon completion of your order prior to
                      installation.
                    </h4>
                      </span>
                    </h4>
                  </v-col>
                </v-row>
                <!-- <v-row
                  :style="{
                    color: $store.state.currentOrg.orderSecondaryColour
                      ? $store.state.currentOrg.orderSecondaryColour
                      : $store.state.currentOrg.secondaryColour,
                  }"
                  v-if="network.routerInstallationFee"
                  style="padding-left: 50px"
                >
                  <v-col cols="12" sm="12">
                    <h4
                      v-if="
                        network.routerInstallationFee && (network.residentialRouterInstallationFeeAmount > 0 || network.businessRouterInstallationFeeAmount > 0)
                      "
                      class="align-left"
                    >
                      An installation fee of
                      <b>{{ network.residentialRouterInstallationFeeAmount | currency }} </b> applies for Residential Packages and
                      <b>{{ network.businessRouterInstallationFeeAmount | currency }}</b> for Business Packages.
                    </h4>
                    <h4
                      v-else-if="network.routerInstallationFee && network.residentialRouterInstallationFeeAmount > 0"
                      class="text-xs-left"
                    >
                      An installation fee of
                      <b>{{ network.residentialRouterInstallationFeeAmount | currency }}</b> may apply upon completion of your order prior to
                      installation.
                    </h4>
                  </v-col>
                </v-row> -->
    <v-toolbar  v-if="!hideToolbar"
                    flat
                    color="white"
                    style="margin:"
                  >
                    <v-container v-if="!$route.query.isp">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-menu offset-y open-on-hover>
                            <template v-slot:activator="{ on }">
                              <v-btn block depressed color="secondary" v-on="on" Large>
                                <h2 style="color: white">SORT <v-icon>arrow_drop_down</v-icon></h2>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-container style="text-align: center">
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item @click="sortpackages('PLTH')"
                                      ><v-list-item-title
                                        :style="{
                                          color: $store.state.currentOrg.orderSecondaryColour
                                            ? $store.state.currentOrg.orderSecondaryColour
                                            : $store.state.currentOrg.secondaryColour,
                                        }"
                                        style="cursor: pointer"
                                        >Price (Low-High)</v-list-item-title
                                      >
                                    </v-list-item>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item @click="sortpackages('PHTL')"
                                      ><v-list-item-title
                                        :style="{
                                          color: $store.state.currentOrg.orderSecondaryColour
                                            ? $store.state.currentOrg.orderSecondaryColour
                                            : $store.state.currentOrg.secondaryColour,
                                        }"
                                        style="cursor: pointer"
                                        >Price (High-Low)</v-list-item-title
                                      >
                                    </v-list-item>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item @click="sortpackages('SLTH')"
                                      ><v-list-item-title
                                        :style="{
                                          color: $store.state.currentOrg.orderSecondaryColour
                                            ? $store.state.currentOrg.orderSecondaryColour
                                            : $store.state.currentOrg.secondaryColour,
                                        }"
                                        style="cursor: pointer"
                                        >Speed (Low-High)</v-list-item-title
                                      >
                                    </v-list-item>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item @click="sortpackages('SHTL')"
                                      ><v-list-item-title
                                        :style="{
                                          color: $store.state.currentOrg.orderSecondaryColour
                                            ? $store.state.currentOrg.orderSecondaryColour
                                            : $store.state.currentOrg.secondaryColour,
                                        }"
                                        style="cursor: pointer"
                                        >Speed (High-Low)</v-list-item-title
                                      >
                                    </v-list-item>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-container> 
                     <v-container v-if="!$vuetify.breakpoint.xs && !$route.query.isp">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-menu offset-y open-on-hover>
                            <template v-slot:activator="{ on }">
                              <v-btn depressed block color="secondary" v-on="on" Large>
                                <h2
                                  style="color: white"
                                  :class="{
                                    mobileStep: $vuetify.breakpoint.xsOnly,
                                  }"
                                >
                                  SPEED <v-icon>arrow_drop_down</v-icon>
                                </h2>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-container style="text-align: center">
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item-title
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      class="px-2 subheading font-weight-bold"
                                      >Download Speed:</v-list-item-title
                                    >
                                  </v-col></v-row
                                >
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-range-slider
                                      class="px-5"
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      v-model="speedDownloadFilter"
                                      style="font-size: 15px"
                                      :value="[0, 1]"
                                      :tick-labels="downloadLabels"
                                      min="0"
                                      :max="downloadLabels.length - 1"
                                    >
                                    </v-range-slider>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item-title
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      class="px-2 subheading font-weight-bold"
                                      >Upload Speed:</v-list-item-title
                                    >
                                  </v-col></v-row
                                >
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-range-slider
                                      class="px-5"
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      v-model="speedUploadFilter"
                                      style="font-size: 15px"
                                      :value="[0, 1]"
                                      :tick-labels="uploadLabels"
                                      min="0"
                                      :max="uploadLabels.length - 1"
                                    >
                                    </v-range-slider>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-container v-if="!$route.query.isp">
                      <v-row justify="center">
                        <v-col cols="12" sm="12">
                          <v-menu offset-y open-on-hover >
                            <template v-slot:activator="{ on }">
                              <v-btn depressed block color="secondary" v-on="on" Large>
                                <h2
                                  style="color: white"
                                  :class="{
                                    mobileStep: $vuetify.breakpoint.xsOnly,
                                  }"
                                >
                                  PROVIDER <v-icon>arrow_drop_down</v-icon>
                                </h2>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-container>
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      style="cursor: pointer"
                                      @click="filterProvider = null"
                                    >
                                      <v-list-item-title
                                        style="cursor: pointer"
                                        :style="{
                                          color: $store.state.currentOrg.orderSecondaryColour
                                            ? $store.state.currentOrg.orderSecondaryColour
                                            : $store.state.currentOrg.secondaryColour,
                                        }"
                                        >All ISP's</v-list-item-title
                                      >
                                    </v-list-item>
                                  </v-col></v-row
                                >
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item
                                      style="cursor: pointer"
                                      v-for="x in providerList"
                                      :key="x.id"
                                      @click="filterProvider = x.id"
                                    >
                                      <v-list-item-avatar tile size="60">
                                        <v-img contain :src="x.logo"></v-img>
                                      </v-list-item-avatar>
                                      <v-list-item-content>
                                        <v-list-item-title
                                          style="cursor: pointer"
                                          :style="{
                                            color: $store.state.currentOrg.orderSecondaryColour
                                              ? $store.state.currentOrg.orderSecondaryColour
                                              : $store.state.currentOrg.secondaryColour,
                                          }"
                                          >{{ x.name }}</v-list-item-title
                                        >
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-col></v-row
                                >
                              </v-container>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-container>
</v-toolbar>
<v-row justify="center">
  <v-col cols="12" v-if="loading" style="text-align: center">
  <v-progress-circular indeterminate color="primary"></v-progress-circular>
  <h3 style="color: grey">Loading Packages...</h3>
  </v-col>
  <v-col  cols="12" style="text-align: center">
<PackagesIspsCards
                            :cardsPerPage="12"
                            :packagesIsps="filteredPackages"
                            @selectPackage="selectPackage"
                            @proceed="proceed($event)"
                            @hideToolbar="hideToolbar = true"
                            @showToolbar="hideToolbar = false"

                          ></PackagesIspsCards>
                          <span style="color: grey" v-if="!loading && filteredPackages.length == 0">No packages found.</span>
  </v-col>

</v-row>

    </div>
</template>
<script>
import PackagesIspsCards from "@/components/PackagesIspsCards.vue";

export default {
    components: {
        PackagesIspsCards
    },
    props: ['network', 'packagesIsps', 'providerList', 'loading'],
    computed: {
        filteredPackages(){
            let result = this.packagesIsps
            if(this.filterProvider){
                result = result.filter(x=>x.customerOrganisationId == this.filterProvider)
            }
            if(this.speedDownloadFilter.length>0){
              result = result.filter(x=>x.packagesFno.speedProfile.downloadMbps >= this.downloadLabels[this.speedDownloadFilter[0]] && x.packagesFno.speedProfile.downloadMbps <= this.downloadLabels[this.speedDownloadFilter[1]])
            }

            if(this.speedUploadFilter.length>0){
              result = result.filter(x=>x.packagesFno.speedProfile.uploadMbps >= this.uploadLabels[this.speedUploadFilter[0]] && x.packagesFno.speedProfile.uploadMbps <= this.uploadLabels[this.speedUploadFilter[1]])
            }
            return result
        }
    },
    data(){
        return {
          downloadLabels: [],
          uploadLabels: [],
          speedDownloadFilter: [],
          speedUploadFilter: [],
            filter: {},
            filterProvider: null,
            hideToolbar: false,
            key: 0
        }
    },
    created(){
      this.downloadLabels = [...new Set(this.packagesIsps.map(x=>x.packagesFno.speedProfile.downloadMbps))].sort((a, b) => a - b)
      this.uploadLabels = [...new Set(this.packagesIsps.map(x=>x.packagesFno.speedProfile.uploadMbps))].sort((a, b) => a - b)
      this.speedDownloadFilter[0] = this.downloadLabels.indexOf(Math.min(...this.downloadLabels));
      this.speedDownloadFilter[1] = this.downloadLabels.indexOf(Math.max(...this.downloadLabels));

      this.speedUploadFilter[0] = this.uploadLabels.indexOf(Math.min(...this.uploadLabels));
      this.speedUploadFilter[1] = this.uploadLabels.indexOf(Math.max(...this.uploadLabels));
      this.sortpackages('PLTH')
    },
    methods: {
    //     filterPackages(code, value) {
    //   let tempPackages = [];
    //   if (code == "ISP") {
    //     if (value == "All") {
    //       tempPackages = this.allPackages;
    //     } else {
    //       this.packagesIsps = [];
    //       for (let i = 0; i < this.allPackages.length; i++) {
    //         if (this.allPackages[i].customerOrganisation.name == value) {
    //           tempPackages.push(this.allPackages[i]);
    //         }
    //       }
    //     }
    //   } else {
    //     tempPackages = this.allPackages;
    //   }
    //   // slider filter
    //   let tempPackages2 = [];
    //   for (let k = 0; k < tempPackages.length; k++) {
    //     if (
    //       tempPackages[k].packagesFno.speedProfile.downloadMbps >=
    //         this.filter.downloadLabels[this.filter.speedDownload[0]] &&
    //       tempPackages[k].packagesFno.speedProfile.downloadMbps <=
    //         this.filter.downloadLabels[this.filter.speedDownload[1]] &&
    //       tempPackages[k].packagesFno.speedProfile.uploadMbps >= this.filter.uploadLabels[this.filter.speedUpload[0]] &&
    //       tempPackages[k].packagesFno.speedProfile.uploadMbps <= this.filter.uploadLabels[this.filter.speedUpload[1]]
    //     ) {
    //       tempPackages2.push(tempPackages[k]);
    //     }
    //   }
    //   this.packagesIsps = tempPackages2;

    //   //IsBusiness Filter
    //   let tempPackages3 = [];
    //   for (let ii = 0; ii < tempPackages2.length; ii++) {
    //     if (tempPackages2[ii].packagesFno.packagesFnoCat.packageCatType == "Business" && this.filter.showBusiness) {
    //       tempPackages3.push(tempPackages2[ii]);
    //     } else if (
    //       tempPackages2[ii].packagesFno.packagesFnoCat.packageCatType == "Residential" &&
    //       this.filter.showResidential
    //     ) {
    //       tempPackages3.push(tempPackages2[ii]);
    //     } else if (this.filter.showAll) {
    //       tempPackages3.push(tempPackages2[ii]);
    //     }
    //   }
    //   this.packagesIsps = tempPackages3;
    // },
        filterPackageSpeeds(downMin, downMax, upMin, upMax) {
      this.packagesIsps = this.allPackages.filter(function(el) {
        return (
          el.packagesFno.speedProfile.downloadMbps >= downMin &&
          el.packagesFno.speedProfile.downloadMbps <= downMax &&
          el.packagesFno.speedProfile.uploadMbps >= upMin &&
          el.packagesFno.speedProfile.uploadMbps <= upMax
        );
      });
    },
    HighToLowSort(property) {
      var sortOrder = -1;
      if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function(a, b) {
        var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    LowToHighSort(property) {
      var sortOrder = 1;
      if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function(a, b) {
        var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    proceed(evt){
            console.log(evt)

        this.$emit('proceed', evt)
        },
        selectPackage(evt){
            console.log(evt)
        },
        sortpackages(key) {
      if (key == "PHTL") {
        this.packagesIsps = this.packagesIsps.sort(this.HighToLowSort("recurringPriceVatInc"));
      }
      if (key == "PLTH") {
        this.packagesIsps = this.packagesIsps.sort(this.LowToHighSort("recurringPriceVatInc"));
      }
      if (key == "SHTL") {
        this.packagesIsps = this.packagesIsps.sort(this.HighToLowSort("downloadMbps"));
      }
      if (key == "SLTH") {
        this.packagesIsps = this.packagesIsps.sort(this.LowToHighSort("downloadMbps"));
      }
      console.log('Sorted ' + key, this.packagesIsps)
    },
    }
    
}
</script>